import { render, staticRenderFns } from "./HeaderMessage.vue?vue&type=template&id=6205e7ee&"
import script from "./HeaderMessage.vue?vue&type=script&lang=js&"
export * from "./HeaderMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports